import { Typography, Button } from "../../components"
import "./styles.css";

export default function RoutekaartBeleidsmakers(props) {
    return (
        <div className="container">
            <iframe
                title="Routekaart NOLIA BabyFeeding voor beleidsmakers"
                src="https://app.enormail.eu/subscribe/273935cfc0434b81029255e8af47cdbe"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}